<template>
  <footer class="footer">
    <div class="footer-content">
      <div class="footer-section">
        <h3>联系我们</h3>
        <!-- <p>电话：123-456-7890</p> -->
        <p>邮箱：caojinshi@krenwu.cn</p>
        <p>地址：北京市通州区宋庄镇小堡村南街甲1号2239室</p>
      </div>
      <div class="footer-section">
        <!-- <h3>关注我们</h3>
        <div class="social-links">
          <a href="#" target="_blank">微信</a>
          <a href="#" target="_blank">微博</a>
          <a href="#" target="_blank">LinkedIn</a>
        </div> -->
      </div>
    </div>
    <div class="footer-bottom">
      <p>Copyright © 2024 北京云璞科技有限公司 · Beijing Yunpu Technology Co., Ltd. <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">京ICP备2024098281号-1</a></p>
    </div>
  </footer>
</template>

<script lang="ts">
export default {
  name: 'Footer'
}
</script>

<style lang="scss" scoped>
.footer {
  background: #f5f5f5;
  padding: 2rem 0;
  margin-top: auto;

  .footer-content {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 1rem;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 2rem;
  }

  .footer-section {
    h3 {
      margin-bottom: 1rem;
      color: #333;
    }

    p {
      color: #666;
      margin-bottom: 0.5rem;
    }
  }

  .social-links {
    display: flex;
    gap: 1rem;

    a {
      color: #666;
      text-decoration: none;

      &:hover {
        color: #1890ff;
      }
    }
  }

  .footer-bottom {
    text-align: center;
    margin-top: 2rem;
    padding-top: 1rem;
    border-top: 1px solid #ddd;
    color: #666;

    a {
      color: #666;
      text-decoration: none;

      &:hover {
        color: #1890ff;
        text-decoration: underline;
      }
    }
  }
}
</style> 